import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import Dariddima from './Dariddima';

ReactDOM.render(
  <React.StrictMode>
    <Dariddima />
  </React.StrictMode>,
  document.getElementById('root')
);
